import React, { useState, useEffect } from 'react'
import { Template } from '../../Components/Template/template'
import { Link } from 'react-router-dom'
import {
    AlertType, FormaPagamento, classBorderLabelDark, classBt, classDivBackground, classDivBody, classDivTitulo,
    classInput, classInputDark, classLabel, classLabelDark, classWeigthBt, classWeigthDiv, classbtColunasAzul, classbtColunasVermelho, classbtVermelho
} from '../../Utils/Types'
import { IoCloseCircleOutline, IoSearch, IoTrash } from 'react-icons/io5'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { FormaPagamentoService } from './FormaPagamentoService'
import { GridFormaPgtoExcluido } from '../../Components/GridExcluidos/GridFormPgtoExcluido'
import moment from 'moment'
import { FaTrashAlt } from 'react-icons/fa'

export const FormaPagtoExcluidos = () => {

    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    let dateI = moment()
        .utcOffset('-03:00')
        .add(-31, 'days')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    const [formaPgtoExcluidos, setFormaPgtoExcluidos] = useState<FormaPagamento[]>([])

    const [datai, setDatai] = useState(dateI)
    const [dataf, setDataf] = useState(dateF)
    const [descricao, setDescricao] = useState("")

    //----------------------------------------------------------------------------------- REQUISIÇÕES API, USEEFFECT E ATALHOS ----------------------------------------------------------------------------//
    const getFormaPagExcluidas = async () => {
        setLoading(true)

        try {

            const relatorio = {
                datai: datai,
                dataf: dataf,
                descricao: descricao
            }

            const retAPI = await FormaPagamentoService.FilterExcluidas(relatorio)

            if (!retAPI.error) {
                setFormaPgtoExcluidos(retAPI.data || [])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar as formas de pagamento excluídas")

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                InputFocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)
        setFormaPgtoExcluidos([])
        InputDesfocus()

        try {

            const relatorio = {
                datai: datai,
                dataf: dataf,
                descricao: descricao
            }

            const retAPI = await FormaPagamentoService.FilterExcluidas(relatorio)

            if (retAPI.error === true) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(retAPI.msg || "")

            } else {
                setFormaPgtoExcluidos(retAPI.data || [])
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage("Não foi possível buscar as formas de pagamento excluídas")

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                InputFocus()
                clearTimeout(timer)
            }, 500)

        }
    }

    const handleMouseUp = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        InputFocus()
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    const handleKeyPressEnter = async (e: any) => {
        if ((e.code === "Enter" || e.code === "NumpadEnter") && !loading) {
            await handleFilterClick()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }
    }, [datai, dataf, descricao, loading])

    useEffect(() => {
        getFormaPagExcluidas()
    }, [])

    //-------------------------------------------------------------------------------------------- INPUTS ----------------------------------------------------------------------------//
    const handleChangeDescricao = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    }

    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    //--------------------------------------------------------------------------------------- FOCUS E STATES ----------------------------------------------------------------------------//
    const handleCloseMessage = () => {
        setVisible(false)
    }

    const InputFocus = () => {
        const inputElement = document.getElementById("descricao_formaPagto_delete")
        inputElement?.focus()
    }

    const InputDesfocus = () => {
        const inputElement = document.getElementById("descricao_formaPagto_delete")
        inputElement?.blur()
    }

    const limparCampoFilter = () => {
        setDescricao('')
    }

    return (
        <Template isLoading={loading} >

            <div className={`${classDivBackground}`}>

                <div id="div-body" role='button' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    {/* TITULO */}
                    <div className={`${classDivTitulo} mb-1 flex flex-row`}>

                        <div className={`flex items-center w-full`}>
                            <FaTrashAlt className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Formas de Pagamento Excluídas</span>
                        </div>

                        <div className={`flex justify-end items-center px-2 ${classWeigthDiv}`}>
                            <Link onMouseUp={handleMouseUp} to="/formaPagto" className={`${classbtColunasVermelho} h-9`}>
                                <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                            </Link>
                        </div>

                    </div>
                    {/* TITULO */}


                    <div className={`w-auto h-auto rounded-md bg-white dark:bg-slate-600 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 cursor-default py-4`}>

                        <div className={`w-auto h-auto grid grid-cols-12 gap-3 px-3`}>

                            <div className={`relative col-span-12 md:col-span-4 xl:col-span-6 mt-2 `}>
                                <input id="descricao_formaPagto_delete" className={`${classInput} ${classInputDark}`} type='text' inputMode='text' placeholder=' ' autoComplete='off' value={descricao} onChange={handleChangeDescricao} />
                                <label htmlFor="descricao_formaPagto_delete" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>
                                <button onClick={limparCampoFilter} className={`absolute right-2 bottom-0 top-0 text-slate-400 outline-none ${descricao === '' ? 'invisible' : 'visible'}`}>
                                    <IoCloseCircleOutline size="25px" />
                                </button>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2 mt-2`}>
                                <input id="data_inicial_formaPagto_delete" className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} disabled={loading} onChange={handleChangeDtInicio} />
                                <label htmlFor="data_inicial_formaPagto_delete" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Exclusão Inicial</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 md:col-span-3 xl:col-span-2 mt-2`}>
                                <input id="data_final_formaPagto_delete" className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} disabled={loading} onChange={handleChangeDtFim} />
                                <label htmlFor="data_final_formaPagto_delete" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Data de Exclusão Final</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 md:col-span-2  mt-2`}>
                                <button disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} `} onClick={handleFilterClick} >
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {!loading && `Pesquisar`} {loading && `Aguarde`}
                                    </span>
                                </button>
                            </div>

                        </div>

                    </div>

                    {/* GRID */}
                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 bg-white dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>
                        <GridFormaPgtoExcluido formaPgto={formaPgtoExcluidos} />
                    </div>
                    {/* GRID */}

                </div>

            </div>

        </Template >
    )
}